<!-- 流量中心 -->
<!-- 流量中心 -->
<template>
    <div class="acout" ref="basicInfo">
        <HomeIndex v-if="typeIndex == 1"  @updateType="updateType"></HomeIndex>
        <ChangeRecord v-else-if="typeIndex == 2" @updateType="updateType"></ChangeRecord>
        <Recharge v-else-if="typeIndex == 3"  @updateType="updateType"></Recharge>
    </div>
</template>
<script>
import HomeIndex from './components/homeIndex.vue';
import ChangeRecord from './components/changeRecord.vue';
import Recharge from './components/recharge.vue';
export default {
    components: {
        HomeIndex,
        ChangeRecord,
        Recharge
    },

    data() {
        return {
            typeIndex: 1
        }
    },
    methods: {
        updateType(type) {
            this.typeIndex = type;
        }
    },
   

}
</script>
<style scoped lang="less">

</style>